export default function removeAllSlides() {
  const swiper = this;
  const slidesIndexes = [];

  for (let i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/modules/manipulation/methods/removeAllSlides.js
// module id = 1215
// module chunks = 9